import type { Widget, WidgetOutput, WidgetParameter } from "../../../../types/widget";

export const DEFAULT_PARAMETERS: WidgetParameter[] = [
  { name: "from", type: "datetime", bind: "dashboard.dateFrom", required: true },
  { name: "to", type: "datetime", bind: "dashboard.dateTo", required: true },
];

/** Ensure dashboard from/to binds exist (e.g. after switching to ADAPTOR). */
export function ensureDashboardDateParameters(
  parameters?: WidgetParameter[] | null
): WidgetParameter[] {
  const list = parameters?.length ? [...parameters] : [];
  const names = new Set(list.map((p) => p.name).filter(Boolean));
  for (const def of DEFAULT_PARAMETERS) {
    if (!names.has(def.name)) {
      list.push({ ...def });
    }
  }
  return list.length ? list : DEFAULT_PARAMETERS.map((p) => ({ ...p }));
}

export const DEFAULT_DSL = `{
  "size": 0,
  "query": {
    "bool": {
      "filter": [
        {
          "range": {
            "{{timeField}}": {
              "gte": "{{from}}",
              "lte": "{{to}}",
              "format": "strict_date_optional_time"
            }
          }
        }
      ]
    }
  }
}`;

export const DEFAULT_TABLE_DSL = `{
  "size": 100,
  "query": {
    "bool": {
      "filter": [
        {
          "range": {
            "{{timeField}}": {
              "gte": "{{from}}",
              "lte": "{{to}}",
              "format": "strict_date_optional_time"
            }
          }
        }
      ]
    }
  }
}`;

export const DEFAULT_MAPPING = `{
  "chartType": "bar",
  "optionTemplate": {
    "title": { "text": "{{widget.name}}" },
    "xAxis": { "type": "category", "data": [] },
    "yAxis": { "type": "value" },
    "series": [{ "type": "bar", "data": [] }]
  }
}`;

export const EMPTY_TABLE_MAPPING = `{
  "columns": []
}`;

export const OUTPUT_FORMAT_VALUES: NonNullable<WidgetOutput["format"]>[] = [
  "echarts",
  "table",
  "text",
  "html",
];

export function emptyWidget(): Widget {
  return {
    name: "",
    description: "",
    dataSource: {
      sources: [{ index: "", timeField: "" }],
      indices: [],
      timeField: "",
      dslTemplate: JSON.parse(DEFAULT_DSL),
      parameters: DEFAULT_PARAMETERS,
    },
    output: {
      format: "echarts",
      mapping: JSON.parse(DEFAULT_MAPPING),
    },
  };
}

export function parseJsonField(raw: string, fieldLabel: string): Record<string, unknown> {
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    throw new Error(`${fieldLabel}: invalid JSON`);
  }
}

export function isValidJson(raw: string): boolean {
  try {
    JSON.parse(raw);
    return true;
  } catch {
    return false;
  }
}
